import localforage from 'localforage';

const storeConfig = localforage.createInstance({
    name: 'storeConfig'
});

export default storeConfig;